import React from "react";
import { themes } from "services/constants";
import * as Mui from "@mui/material";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tooltip,
  Paper,
} from "@mui/material";
import { cardBorder } from "services/constants";
import { tooltipStyleProps } from "services/constants/Styles";
import { stickyHeader } from "services/constants";

export const ShiftPreview = ({
  representationWeekdays,
  representationShifts,
  editSftRotaData,
  shiftRotationDetails,
  representationNonRandon,
}) => {
  const weekDays = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
  const previewAutoShiftBeforeStart =
    editSftRotaData?.start_buffer === ""
      ? "0"
      : editSftRotaData?.start_buffer ??
        editSftRotaData?.auto_shift_before_start ??
        "60";
  const previewAutoShiftAfterStart =
    editSftRotaData?.end_buffer === ""
      ? "0"
      : editSftRotaData?.end_buffer ??
        editSftRotaData?.auto_shift_after_start ??
        "90";
  const previewContinueDetectionUntilShiftEnd = Boolean(
    editSftRotaData?.is_shift_full_time,
  );

  console.log(representationNonRandon);

  console.log(editSftRotaData);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2.5,
          }}
        >
          <Box mb={8}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ color: themes?.headLine }}
              textAlign="center"
              mb={4}
            >
              {editSftRotaData?.name}
            </Typography>
            <Grid container spacing={3} mb={6}>
              <Grid item xs={12} lg={6}>
                <Box display="flex" flexDirection="column" gap={3}>
                  <Card sx={{ ...cardBorder, height: "100%" }}>
                    <CardContent sx={{ p: 3, height: "100%" }}>
                      <Box mb={1} display="flex" alignItems="center">
                        <Typography
                          variant="body1"
                          fontWeight={500}
                          color="#09bd71"
                        >
                          Shift:
                        </Typography>
                        <Typography variant="body1" fontWeight="bold" ml={1}>
                          {editSftRotaData?.shifts?.length}
                        </Typography>
                      </Box>

                      <Box mb={2}>
                        {editSftRotaData?.shifts.map((shift, index) => (
                          <Typography key={index} fontWeight={500}>
                            {shift?.shift_name}
                          </Typography>
                        ))}
                      </Box>
                    </CardContent>
                  </Card>

                  <Card sx={{ ...cardBorder, height: "100%" }}>
                    <CardContent sx={{ p: 3, height: "100%" }}>
                      <Box mb={2} display="flex" alignItems="center">
                        <Typography
                          variant="body1"
                          fontWeight={500}
                          color="#09bd71"
                        >
                          Shift Groups:
                        </Typography>
                        <Typography variant="body1" fontWeight="bold" ml={1}>
                          {editSftRotaData?.shift_groups?.length}
                        </Typography>
                      </Box>

                      <Box mb={2}>
                        {editSftRotaData?.shift_groups?.length > 0 ? (
                          editSftRotaData.shift_groups.map((group, index) => (
                            <Typography key={index} fontWeight={500}>
                              {group?.shift_group_name}
                            </Typography>
                          ))
                        ) : (
                          <Typography color="text.secondary">
                            No shift groups available
                          </Typography>
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                </Box>
              </Grid>
              {(editSftRotaData?.rotation_based_on === "Weekdays" ||
                editSftRotaData?.rotation_based_on === "Shift") &&
              editSftRotaData?.number_of_shifts !== 1 ? (
                <Grid item xs={12} lg={6}>
                  <Card sx={{ ...cardBorder, width: "100%" }}>
                    <CardContent sx={{ p: 3, height: "100%" }}>
                      <Typography
                        variant="body1"
                        fontWeight={500}
                        color="#09bd71"
                        sx={{ mb: 1 }}
                      >
                        Rotation
                      </Typography>
                      {[
                        {
                          label: "Shift Type",
                          value: editSftRotaData?.shift_type,
                        },
                        {
                          label: "Based on",
                          value:
                            editSftRotaData?.rotation_based_on === "Weekdays"
                              ? representationWeekdays.rotation_based_on
                              : shiftRotationDetails?.rotation_based_on,
                        },
                        {
                          label: "Frequency",
                          value:
                            editSftRotaData?.rotation_based_on === "Weekdays"
                              ? representationWeekdays.rotation_frequency
                              : shiftRotationDetails?.rotation_frequency,
                        },
                        {
                          label: "Rotation Day",
                          value:
                            editSftRotaData?.rotation_based_on === "Weekdays"
                              ? representationWeekdays.rotation_day
                              : shiftRotationDetails?.rotation_day,
                        },
                        {
                          label: "No of Repetition",
                          value:
                            editSftRotaData?.rotation_based_on === "Weekdays"
                              ? representationWeekdays.no_of_repetition
                              : shiftRotationDetails?.no_of_repetition,
                        },
                        {
                          label: "Effective From",
                          value:
                            editSftRotaData?.rotation_based_on === "Weekdays"
                              ? representationWeekdays.start_date
                              : shiftRotationDetails?.start_date,
                        },
                        {
                          label: "First Rotation on",
                          value:
                            editSftRotaData?.rotation_based_on === "Weekdays"
                              ? representationWeekdays.first_rotation_date
                              : shiftRotationDetails?.first_rotation_date,
                        },
                        {
                          label: "Enable Auto Shift Assign",
                          value: editSftRotaData?.auto_shift_assign
                            ? "Yes"
                            : "No",
                        },
                      ].map((item, i) => (
                        <Grid container key={i} spacing={1} sx={{ mb: 2 }}>
                          <Grid item xs={6}>
                            <Typography variant="body2" color="text.secondary">
                              {item.label}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography fontWeight={500}>
                              {item.value}
                            </Typography>
                          </Grid>
                        </Grid>
                      ))}
                    </CardContent>
                  </Card>
                </Grid>
              ) : (
                <Grid item xs={12} lg={6}>
                  {editSftRotaData?.length !== 0 && (
                    <Card sx={cardBorder}>
                      <CardContent sx={{ p: 3 }}>
                        <Typography
                          variant="body1"
                          fontWeight={500}
                          color="#09bd71"
                          sx={{ mb: 1 }}
                        >
                          Rotation
                        </Typography>
                        {[
                          {
                            label: "Shift Type",
                            value: editSftRotaData?.shift_type,
                          },
                          {
                            label: "Effective From",
                            value: editSftRotaData?.start_date,
                          },
                        ].map((item, i) => (
                          <Grid container key={i} spacing={1} sx={{ mb: 2 }}>
                            <Grid item xs={6}>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {item.label}
                              </Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <Typography fontWeight={500}>
                                {item.value}
                              </Typography>
                            </Grid>
                          </Grid>
                        ))}
                      </CardContent>
                    </Card>
                  )}
                </Grid>
              )}
            </Grid>
            {editSftRotaData?.auto_shift_assign ? (
              <Card sx={{ ...cardBorder, mb: 4 }}>
                <CardContent sx={{ p: 3 }}>
                  <Typography
                    variant="body1"
                    fontWeight={500}
                    color="#09bd71"
                    sx={{ mb: 1 }}
                  >
                    Auto Shift Detection (First IN Punch)
                  </Typography>
                  <Grid
                    container
                    spacing={2}
                    sx={{
                      mb: 1,
                      display: "grid",
                      gridTemplateColumns: "1fr 0.8fr 1.6fr",
                    }}
                  >
                    <Grid item xs={12} sx={{ minWidth: 0 }}>
                      <Typography variant="body2" color="text.secondary">
                        Before Shift Start
                      </Typography>
                      <Typography fontWeight={500}>
                        {previewAutoShiftBeforeStart} min
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sx={{ minWidth: 0 }}>
                      <Typography variant="body2" color="text.secondary">
                        After Shift Start
                      </Typography>
                      <Typography fontWeight={500}>
                        {previewAutoShiftAfterStart} min
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sx={{ minWidth: 0 }}>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ whiteSpace: "nowrap" }}
                      >
                        Continue Detection Until Shift End
                      </Typography>
                      <Typography fontWeight={500}>
                        {previewContinueDetectionUntilShiftEnd
                          ? "Enabled"
                          : "Disabled"}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            ) : null}
            {editSftRotaData?.rotation_based_on === "Weekdays" &&
            editSftRotaData?.number_of_shifts !== 1 ? (
              <Box mb={4}>
                {representationWeekdays?.shift_groups?.map((shift) => (
                  <>
                    <Mui.Grid container sx={{ ml: 1, mt: 2 }}>
                      <Typography
                        variant="body1"
                        fontWeight={500}
                        color="#09bd71"
                      >
                        {shift?.shift_group_name}
                      </Typography>
                    </Mui.Grid>
                    <TableContainer
                      component={Paper}
                      sx={{
                        marginTop: 2,
                        marginLeft: "auto",
                        marginRight: "auto",
                        overflowX: "auto",
                        width: "100%",
                        maxWidth: 1300,
                        maxHeight: 450,
                      }}
                    >
                      <Table
                        sx={{
                          width: "100%",
                          tableLayout: "auto",
                          border: "1px solid #0000002b",
                        }}
                      >
                        <TableHead sx={stickyHeader}>
                          <TableRow>
                            <TableCell
                              sx={{
                                minWidth: 80,
                                fontWeight: 600,
                                textAlign: "center",
                                backgroundColor: themes.primary,
                                borderRight: "1px solid #0000002b",
                                borderBottom: "1px solid #0000002b",
                                position: "sticky",
                                left: -1,
                                zIndex: 1,
                              }}
                            >
                              Cycle
                            </TableCell>
                            {weekDays.map((data, i) => (
                              <TableCell
                                key={i}
                                sx={{
                                  minWidth: 250,
                                  fontWeight: 600,
                                  textAlign: "center",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  backgroundColor: themes.primary,
                                  borderRight: "1px solid #0000002b",
                                  borderBottom: "1px solid #0000002b",
                                }}
                              >
                                {data}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {shift?.cycles?.map((item, index) => (
                            <TableRow key={index}>
                              {/* Cycle column */}
                              <TableCell
                                sx={{
                                  textAlign: "center",
                                  backgroundColor: themes.primary,
                                  borderRight: "1px solid #0000002b",
                                  borderBottom: "1px solid #0000002b",
                                  position: "sticky",
                                  left: -1,
                                  zIndex: 1,
                                }}
                              >
                                Cycle {item?.cycle_number}
                              </TableCell>

                              {item?.assignments?.map((head, idx) => (
                                <TableCell
                                  key={idx}
                                  sx={{
                                    minWidth: 250,
                                    backgroundColor: head?.color_code,
                                    textAlign: "center",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    borderRight: "1px solid #0000002b",
                                    borderBottom: "1px solid #0000002b",
                                  }}
                                >
                                  <Typography
                                    fontSize={14}
                                    fontWeight={500}
                                    mb={0.5}
                                  >
                                    {head?.shift_name}
                                  </Typography>
                                  <Typography fontSize={12}>
                                    {`${head?.start_time?.slice(
                                      0,
                                      5
                                    )} - ${head?.end_time?.slice(0, 5)}`}
                                  </Typography>
                                </TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                ))}
              </Box>
            ) : editSftRotaData?.rotation_based_on === "Shift" &&
              editSftRotaData?.number_of_shifts !== 1 ? (
              <Box mb={4}>
                {representationShifts?.length !== 0 ? (
                  <TableContainer
                    component={Paper}
                    sx={{
                      marginTop: 2,
                      marginLeft: "auto",
                      marginRight: "auto",
                      overflowX: "auto",
                      width: "100%",
                      maxWidth: 1300,
                      maxHeight: 450,
                    }}
                  >
                    <Table
                      sx={{
                        width: "100%",
                        tableLayout: "auto",
                        border: "1px solid #0000002b",
                      }}
                    >
                      <TableHead sx={stickyHeader}>
                        <TableRow>
                          <TableCell
                            sx={{
                              minWidth: 80,
                              fontWeight: 600,
                              textAlign: "center",
                              backgroundColor: themes.primary,
                              borderRight: "1px solid #0000002b",
                              borderBottom: "1px solid #0000002b",
                              position: "sticky",
                              left: -1,
                              zIndex: 1,
                            }}
                          >
                            Cycle
                          </TableCell>
                          <TableCell
                            sx={{
                              minWidth: 250,
                              fontWeight: 600,
                              textAlign: "center",
                              backgroundColor: themes.primary,
                              borderRight: "1px solid #0000002b",
                              borderBottom: "1px solid #0000002b",
                            }}
                          >
                            Date
                          </TableCell>
                          {editSftRotaData?.shift_groups?.length > 0 &&
                            editSftRotaData?.shift_groups?.map((head) => (
                              <Mui.TableCell
                                key={head.shift_group_name}
                                sx={{
                                  fontWeight: 600,
                                  fontSize: 14,
                                  backgroundColor: "#f5f5fd",
                                  borderRight: "1px solid #0000002b",
                                  borderBottom: "1px solid #0000002b",
                                  width: 100,
                                  textAlign: "center",
                                }}
                              >
                                {head.shift_group_name}
                              </Mui.TableCell>
                            ))}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {representationShifts?.map((item, index) => (
                          <TableRow key={index}>
                            <TableCell
                              sx={{
                                textAlign: "center",
                                backgroundColor: themes.primary,
                                borderRight: "1px solid #0000002b",
                                borderBottom: "1px solid #0000002b",
                                position: "sticky",
                                left: -1,
                                zIndex: 1,
                              }}
                            >
                              Cycle {index + 1}
                            </TableCell>
                            <Mui.TableCell
                              sx={{
                                minWidth: 250,
                                textAlign: "center",
                                borderRight: "1px solid #0000002b",
                                borderBottom: "1px solid #0000002b",
                              }}
                            >
                              {item?.date}
                            </Mui.TableCell>
                            {item?.assignment
                              ?.sort(
                                (a, b) =>
                                  a.shift_group_name - b.shift_group_name
                              )
                              .map((head) => (
                                <TableCell
                                  sx={{
                                    minWidth: 200,
                                    backgroundColor: head.color_code,
                                    textAlign: "center",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    borderRight: "1px solid #0000002b",
                                    borderBottom: "1px solid #0000002b",
                                  }}
                                >
                                  <Typography
                                    fontSize={14}
                                    fontWeight={500}
                                    mb={0.5}
                                  >
                                    {head.shift_name}
                                  </Typography>
                                  <Typography fontSize={12}>
                                    {`${head?.start_time?.slice(
                                      0,
                                      5
                                    )} - ${head?.end_time?.slice(0, 5)}`}
                                  </Typography>
                                </TableCell>
                              ))}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : null}
              </Box>
            ) : (
              <>
                {editSftRotaData?.length !== 0 ? (
                  <TableContainer
                    component={Paper}
                    sx={{
                      marginTop: 2,
                      marginLeft: "auto",
                      marginRight: "auto",
                      overflowX: "auto",
                      width: "100%",
                      maxWidth: 1300,
                    }}
                  >
                    <Table
                      sx={{
                        width: "100%",
                        tableLayout: "auto",
                        border: "1px solid #0000002b",
                      }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            sx={{
                              minWidth: 60,
                              fontWeight: 600,
                              textAlign: "center",
                              backgroundColor: themes.primary,
                              borderRight: "1px solid #0000002b",
                              borderBottom: "1px solid #0000002b",
                              position: "sticky",
                              left: -1,
                              zIndex: 1,
                            }}
                          >
                            Cycle
                          </TableCell>
                          <TableCell
                            sx={{
                              minWidth: 120,
                              fontWeight: 600,
                              textAlign: "center",
                              backgroundColor: themes.primary,
                              borderRight: "1px solid #0000002b",
                              borderBottom: "1px solid #0000002b",
                            }}
                          >
                            Date
                          </TableCell>
                          {editSftRotaData?.shift_groups?.map((head) => (
                            <Mui.TableCell
                              sx={{
                                minWidth: 200,
                                fontWeight: 600,
                                textAlign: "center",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                backgroundColor: themes.primary,
                                borderRight: "1px solid #0000002b",
                                borderBottom: "1px solid #0000002b",
                              }}
                            >
                              {head?.shift_group_name}
                            </Mui.TableCell>
                          ))}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: "center",
                              backgroundColor: themes.primary,
                              borderRight: "1px solid #0000002b",
                              borderBottom: "1px solid #0000002b",
                              position: "sticky",
                              left: -1,
                              zIndex: 1,
                            }}
                          >
                            Cycle
                          </TableCell>
                          <Mui.TableCell
                            sx={{
                              textAlign: "center",
                              borderRight: "1px solid #0000002b",
                              borderBottom: "1px solid #0000002b",
                            }}
                          >
                            {editSftRotaData?.start_date}
                          </Mui.TableCell>
                          {representationNonRandon?.shift_groups?.length
                            ? representationNonRandon.shift_groups.map(
                                (group, gIdx) => (
                                  <React.Fragment key={gIdx}>
                                    {group?.cycles.map((cyc, cIdx) => (
                                      <TableCell
                                        key={cIdx}
                                        sx={{
                                          minWidth: 200,
                                          backgroundColor: cyc.color_code,
                                          textAlign: "center",
                                          whiteSpace: "normal",
                                          wordBreak: "break-word",
                                          borderRight: "1px solid #0000002b",
                                          borderBottom: "1px solid #0000002b",
                                        }}
                                      >
                                        <Typography
                                          fontSize={14}
                                          fontWeight={500}
                                          mb={0.5}
                                        >
                                          {cyc.shift_name}
                                        </Typography>
                                        <Typography fontSize={12}>
                                          {`${cyc?.start_time?.slice(
                                            0,
                                            5
                                          )} - ${cyc?.end_time?.slice(0, 5)}`}
                                        </Typography>
                                      </TableCell>
                                    ))}
                                  </React.Fragment>
                                )
                              )
                            : null}
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : null}
              </>
            )}

            <Box
              display="grid"
              gridTemplateColumns="repeat(3, 1fr)"
              gap={3}
              sx={{ ml: 5, mt: 2 }}
            >
              {editSftRotaData?.shifts.map((shift, index) => (
                <Box key={index} display="flex" alignItems="center" gap={1}>
                  <Box
                    sx={{
                      width: 20,
                      height: 20,
                      backgroundColor: shift?.color_code,
                      border: "1px solid #00000040",
                      borderRadius: "2px",
                    }}
                  />
                  <Tooltip
                    title={shift?.shift_name || ""}
                    arrow
                    slotProps={tooltipStyleProps}
                  >
                    <Typography fontWeight={500} noWrap sx={{ maxWidth: 120 }}>
                      {shift?.shift_name}
                    </Typography>
                  </Tooltip>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
